import { render, staticRenderFns } from "./AgroNotificationList.vue?vue&type=template&id=07f5cb5b&"
import script from "./AgroNotificationList.vue?vue&type=script&lang=ts&"
export * from "./AgroNotificationList.vue?vue&type=script&lang=ts&"
import style0 from "./agroNotificationList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports